const LOG_LEVELS = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
} as const;

type LogLevel = keyof typeof LOG_LEVELS;

const rawLevel = (import.meta.env.VITE_LOG_LEVEL as string | undefined)?.toLowerCase();
const envLevel = (Object.keys(LOG_LEVELS) as LogLevel[]).find((level) => level === rawLevel) as LogLevel | undefined;
const defaultLevel: LogLevel = 'warn';
const minLevel = LOG_LEVELS[envLevel ?? defaultLevel] ?? LOG_LEVELS[defaultLevel];

const shouldLog = (level: LogLevel) => LOG_LEVELS[level] >= minLevel;

const noop = () => {};

export const logger = {
  debug: (...args: unknown[]) => {
    if (shouldLog('debug')) {
      console.debug(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (shouldLog('info')) {
      console.info(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (shouldLog('warn')) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};

export const getLogLevel = (): LogLevel =>
  (Object.keys(LOG_LEVELS) as LogLevel[]).find((level) => LOG_LEVELS[level] === minLevel) ?? defaultLevel;

export const configureConsole = (): void => {
  if (minLevel >= LOG_LEVELS.warn) {
    console.debug = noop;
    console.info = noop;
    console.log = noop;
  } else if (minLevel >= LOG_LEVELS.info) {
    console.debug = noop;
  }
};
